import React from "react";
import { observer, inject } from "mobx-react";
import Page from "./Components/Page";

@inject("ApplicationModel")
@observer
export default class Catalog extends React.Component {
	render() {
		return <Page route={this.props.route} />;
	}
}
